import { buildESPNBannerType, applyESPNLogic } from './espn-form-handlers';
import { getMatchData } from './get-match-data';
import { getMatchesForLeague } from './get-matches-for-league';
import { getDynamicOptions } from './get-dynamic-options';
import { applyFieldLogic } from './apply-field-logic';
import { cleanFormData } from './clean-form-data';
import { shouldShowField } from './should-show-field';
import { getBannerMetadata } from './get-banner-metadata';

export const getESPNVSHelpers = () => ({
  buildESPNBannerType,
  applyESPNLogic,
  getMatchData,
  getMatchesForLeague,
  getDynamicOptions,
  applyFieldLogic,
  cleanFormData,
  shouldShowField,
  getBannerMetadata
});

export {
  buildESPNBannerType,
  applyESPNLogic,
  getMatchData,
  getMatchesForLeague,
  getDynamicOptions,
  applyFieldLogic,
  cleanFormData,
  shouldShowField,
  getBannerMetadata
};
